// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RouteModal_overlay__WMUPy {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.RouteModal_modal__7MEWC {
  background: #fff;
  border-radius: 14px;
  width: 95%;
  height: 85vh;
  display: grid;
  grid-template-columns: 60% 6px 1fr;
  grid-template-rows: 1fr;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  position: relative;
}

/* === КАРТА === */
.RouteModal_mapSection__O2Ipt {
  background: #f0f2f7; /* лёгкий фон без белых рамок */
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: stretch;
}

.RouteModal_mapSection__O2Ipt > * {
  flex: 1 1;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 0;
}

/* === РАЗДЕЛИТЕЛЬ === */
.RouteModal_divider__2j0HB {
  position: relative;
  width: 6px;
  cursor: col-resize;
  background: #e0e3eb;
  transition: background 0.15s ease;
  touch-action: none;
}
.RouteModal_divider__2j0HB:hover {
  background: #cfd3de;
}
.RouteModal_divider__2j0HB:active {
  background: #007bff;
  box-shadow: 0 0 8px rgba(0,123,255,0.4);
}
.RouteModal_grip__cSnqU {
  pointer-events: none;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 24px;
  transform: translate(-50%, -50%);
  background: rgba(0,0,0,0.3);
  border-radius: 2px;
}
.RouteModal_divider__2j0HB::before {
  content: "";
  position: absolute;
  left: -6px;
  width: 18px;
  top: 0;
  bottom: 0;
  cursor: col-resize;
}

/* === ПРАВАЯ ПАНЕЛЬ === */
.RouteModal_timelineSection__6n8PB {
  display: flex;
  flex-direction: column;
  background: #fafafa;
  border-left: 1px solid #e0e3eb;
  overflow: hidden;
}

.RouteModal_header__kCs6v {
  padding: 1rem 1.4rem;
  background: #f7f9fc;
  border-bottom: 1px solid #e0e3eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.RouteModal_header__kCs6v h2 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.RouteModal_header__kCs6v button {
  border: none;
  background: transparent;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
}

.RouteModal_timelineScroll__-bUZD {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 1rem 1.4rem;
}

.RouteModal_axisHost__LZMrb {
  position: relative;
  background: #fff;
  overflow: hidden;      /* панорамируем сами, колесом и drag'ом */
  padding: 0.75rem 0.5rem;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;     /* чтобы текст не выделялся при drag */
}

.RouteModal_axisHost__LZMrb.RouteModal_dragging__TX93m {
  cursor: grabbing;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Logist/Routes/modal/RouteModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB,EAAE,+BAA+B;EACpD,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gCAAgC;EAChC,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,MAAM;EACN,SAAS;EACT,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,OAAO,yCAAyC;EAChE,uBAAuB;EACvB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB,MAAM,sCAAsC;AAC/D;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0,0,0,0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 20px;\r\n}\r\n\r\n.modal {\r\n  background: #fff;\r\n  border-radius: 14px;\r\n  width: 95%;\r\n  height: 85vh;\r\n  display: grid;\r\n  grid-template-columns: 60% 6px 1fr;\r\n  grid-template-rows: 1fr;\r\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.25);\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n/* === КАРТА === */\r\n.mapSection {\r\n  background: #f0f2f7; /* лёгкий фон без белых рамок */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  justify-content: stretch;\r\n}\r\n\r\n.mapSection > * {\r\n  flex: 1;\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  border: none;\r\n  border-radius: 0;\r\n}\r\n\r\n/* === РАЗДЕЛИТЕЛЬ === */\r\n.divider {\r\n  position: relative;\r\n  width: 6px;\r\n  cursor: col-resize;\r\n  background: #e0e3eb;\r\n  transition: background 0.15s ease;\r\n  touch-action: none;\r\n}\r\n.divider:hover {\r\n  background: #cfd3de;\r\n}\r\n.divider:active {\r\n  background: #007bff;\r\n  box-shadow: 0 0 8px rgba(0,123,255,0.4);\r\n}\r\n.grip {\r\n  pointer-events: none;\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 2px;\r\n  height: 24px;\r\n  transform: translate(-50%, -50%);\r\n  background: rgba(0,0,0,0.3);\r\n  border-radius: 2px;\r\n}\r\n.divider::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: -6px;\r\n  width: 18px;\r\n  top: 0;\r\n  bottom: 0;\r\n  cursor: col-resize;\r\n}\r\n\r\n/* === ПРАВАЯ ПАНЕЛЬ === */\r\n.timelineSection {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #fafafa;\r\n  border-left: 1px solid #e0e3eb;\r\n  overflow: hidden;\r\n}\r\n\r\n.header {\r\n  padding: 1rem 1.4rem;\r\n  background: #f7f9fc;\r\n  border-bottom: 1px solid #e0e3eb;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.header h2 {\r\n  margin: 0;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.header button {\r\n  border: none;\r\n  background: transparent;\r\n  font-size: 1.5rem;\r\n  cursor: pointer;\r\n  color: #666;\r\n}\r\n\r\n.timelineScroll {\r\n  flex: 1 1 auto;\r\n  overflow-y: auto;\r\n  padding: 1rem 1.4rem;\r\n}\r\n\r\n.axisHost {\r\n  position: relative;\r\n  background: #fff;\r\n  overflow: hidden;      /* панорамируем сами, колесом и drag'ом */\r\n  padding: 0.75rem 0.5rem;\r\n  cursor: grab;\r\n  user-select: none;     /* чтобы текст не выделялся при drag */\r\n}\r\n\r\n.axisHost.dragging {\r\n  cursor: grabbing;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `RouteModal_overlay__WMUPy`,
	"modal": `RouteModal_modal__7MEWC`,
	"mapSection": `RouteModal_mapSection__O2Ipt`,
	"divider": `RouteModal_divider__2j0HB`,
	"grip": `RouteModal_grip__cSnqU`,
	"timelineSection": `RouteModal_timelineSection__6n8PB`,
	"header": `RouteModal_header__kCs6v`,
	"timelineScroll": `RouteModal_timelineScroll__-bUZD`,
	"axisHost": `RouteModal_axisHost__LZMrb`,
	"dragging": `RouteModal_dragging__TX93m`
};
export default ___CSS_LOADER_EXPORT___;
